import { Outlet, useLocation } from 'react-router-dom';
import { Navbar, NavbarItem } from '../../component-lib/catalyst/navbar';
import { useDocumentTitle } from '../../hooks/use-document-title';

export default function MyTasks() {
  useDocumentTitle('Jointflows', 'My tasks ');
  const location = useLocation();
  const isListView = location.pathname.startsWith('/my_tasks/list-view');

  return (
    <div>
      <h1 className="text-3xl font-bold mb-10 uppercase text-black">My tasks</h1>
      <Navbar className="mb-10 border-b border-gray-200">
        <NavbarItem
          href="/"
          current={!isListView}
        >
          Dashboard
        </NavbarItem>
        <NavbarItem
          to="list-view"
          current={isListView}
        >
          List view
        </NavbarItem>
      </Navbar>
      <Outlet />
    </div>
  );
}
